import React from 'react';

// Fleet Distribution metrics using Enum for type safety
export enum DistributionMetric {
  TOTAL_VEHICLES = 'TOTAL_VEHICLES',
  ACTIVE_REPO_CASE = 'ACTIVE_REPO_CASE',
  OPERATIONAL_UTILIZATION = 'OPERATIONAL_UTILIZATION',
  FLEET_HEALTH_SCORE = 'FLEET_HEALTH_SCORE',
}

// Metric configuration mapping - clean and maintainable
export const DISTRIBUTION_CONFIG = {
  [DistributionMetric.TOTAL_VEHICLES]: {
    title: 'Total Fleet Size',
    icon: 'ri-car-line'
  },
  [DistributionMetric.ACTIVE_REPO_CASE]: {
    title: 'Active Repo Case',
    icon: 'ri-alert-line'
  },
  [DistributionMetric.OPERATIONAL_UTILIZATION]: {
    title: 'Operational Utilization',
    icon: 'ri-line-chart-line'
  },
  [DistributionMetric.FLEET_HEALTH_SCORE]: {
    title: 'Fleet Health Score',
    icon: 'ri-heart-pulse-line'
  },
} as const;

export interface FleetCardProps {
  metric: DistributionMetric;
  value: number;
  formatAsPercentage?: boolean;
  onSeeAll?: () => void;
  loading?: boolean;
}

// Fleet Distribution Card Component
const FleetCard: React.FC<FleetCardProps> = ({ metric, value, formatAsPercentage = false, loading = false }) => {
  const config = DISTRIBUTION_CONFIG[metric];
  const safeValue = Number.isFinite(value) ? value : 0;

  // Format value
  const formattedValue = formatAsPercentage
    ? `${safeValue}%`
    : safeValue.toLocaleString('en-US');

  return (
    <div className="flex flex-col justify-between rounded-2xl border border-gray-200 bg-white p-4 shadow-sm min-h-[80px] cursor-default">
      <div>
        <div className="flex items-start justify-start gap-3 min-w-0">
          <div className="text-lg text-neutral-900 flex-shrink-0 w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center">
            <i className={config.icon} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-base text-neutral-600 mb-1">{config.title}</div>
            {loading ? (
              <div className="h-8 w-24 bg-gray-100 animate-pulse rounded mt-2"></div>
            ) : (
              <div className="font-medium text-gray-900 leading-tight tabular-nums text-[28px] whitespace-nowrap">
                {formattedValue}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetCard;